import { FC, useContext, useEffect } from 'react'
import { LOCALES } from '../../../core/i18n/locales'
import OptionsModal from '../../_shared/OptionsModal/OptionsModal'
import { Context } from '../../..'
import { usePhoneMask } from '../hooks/usePhoneMask'
import { Icon } from '../../../components/icons/Icon'
import iconStyles from '../../../styles/Icon.module.scss'
import styles from './PhoneMaskSelectModal.module.scss'

interface PhoneMaskSelectModalProps {
	phoneMaskHook: ReturnType<typeof usePhoneMask>
	phoneCodeUpdated: string
	onSelectionChange?: (data: { phoneCode: string; phoneMask: string; countryEN: string }) => void
}

export const PhoneMaskSelectModal: FC<PhoneMaskSelectModalProps> = ({
	phoneMaskHook,
	phoneCodeUpdated,
	onSelectionChange,
}) => {
	const { studioStore, store } = useContext(Context)

	const handleDone = () => {
		phoneMaskHook.applySelection()
		if (onSelectionChange) {
			onSelectionChange({
				phoneCode: phoneMaskHook.tempPhoneCode,
				phoneMask: phoneMaskHook.tempPhoneMask,
				countryEN: phoneMaskHook.tempCountryEN,
			})
		}
	}

	return (
		<OptionsModal
			height='auto'
			openned={phoneMaskHook.isModalOpen}
			title={store.locale === LOCALES.RUSSIAN ? 'Выбрать код телефона' : 'Select phone code'}
			onClose={phoneMaskHook.closeModal}
			done={store.locale === LOCALES.RUSSIAN ? 'Выбрать' : 'Select'}
			onDone={handleDone}
			actionClassName={styles.actions}
		>
			<div className={styles.countries}>
			<div className='cities_selecting flexed'>
				{studioStore.countries.map((ctr) => (
					<div
						key={ctr.id}
						className={
							'cs_item' +
							((phoneMaskHook.tempPhoneCode === ctr.phone_code || phoneCodeUpdated === ctr.phone_code) &&
							phoneMaskHook.tempCountryEN === ctr.name_en
								? ' selected'
								: '')
						}
						onClick={() => phoneMaskHook.selectCountry(ctr)}
					>
						<div className='cs_item__name'>
							{store.locale === 'ru-RU' ? ctr.name : ctr.name_en}
							<br />
							<small>+{ctr.phone_code}</small>
						</div>
						<div className='cs_item__check'>
							<span>
								<Icon variant={'check'} className={iconStyles.city_check} />
							</span>
						</div>
					</div>
				))}
			</div>
			</div>
		</OptionsModal>
	)
}
